// extracted by mini-css-extract-plugin
export default {"root":"Welcome__root--Rp1Ys","video":"Welcome__video--VHB2x","body":"Welcome__body--wkQqC"};